// COPE-28 (Brief COPE de Carver) — version bilingue FR / ES.
// 28 items, échelle 0–3. 14 stratégies de coping, chacune = somme de 2 items (0–6).

export const COPE_SCALE = {
  fr: [
    { value: 0, label: "Jamais" },
    { value: 1, label: "Un peu" },
    { value: 2, label: "Assez" },
    { value: 3, label: "Beaucoup" },
  ],
  es: [
    { value: 0, label: "Nunca" },
    { value: 1, label: "Un poco" },
    { value: 2, label: "Bastante" },
    { value: 3, label: "Mucho" },
  ],
};

// Items numérotés 1 à 28 (numérotation officielle du Brief COPE).
export const COPE_ITEMS = [
  { n: 1, fr: "J'essaie d'obtenir que quelqu'un m'aide ou me conseille sur ce qu'il faut faire.", es: "Intento conseguir que alguien me ayude o aconseje sobre qué hacer." },
  { n: 2, fr: "Je concentre mes efforts pour agir sur la situation dans laquelle je me trouve.", es: "Concentro mis esfuerzos en hacer algo sobre la situación en la que estoy." },
  { n: 3, fr: "J'accepte la réalité de ce qui est arrivé.", es: "Acepto la realidad de lo que ha sucedido." },
  { n: 4, fr: "Je me tourne vers le travail ou d'autres activités pour me changer les idées.", es: "Recurro al trabajo o a otras actividades para apartar las cosas de mi mente." },
  { n: 5, fr: "Je me dis « ce n'est pas réel ».", es: "Me digo a mí mismo «esto no es real»." },
  { n: 6, fr: "J'essaie d'élaborer une stratégie sur ce qu'il faut faire.", es: "Intento proponer una estrategia sobre qué hacer." },
  { n: 7, fr: "Je plaisante à ce sujet.", es: "Hago bromas sobre ello." },
  { n: 8, fr: "Je me critique moi-même.", es: "Me critico a mí mismo." },
  { n: 9, fr: "J'obtiens du soutien émotionnel de la part des autres.", es: "Consigo apoyo emocional de otros." },
  { n: 10, fr: "Je prends des mesures pour essayer d'améliorer la situation.", es: "Tomo medidas para intentar que la situación mejore." },
  { n: 11, fr: "Je renonce à essayer de m'en occuper.", es: "Renuncio a intentar ocuparme de ello." },
  { n: 12, fr: "Je dis des choses pour laisser libre cours à mes sentiments désagréables.", es: "Digo cosas para dar rienda suelta a mis sentimientos desagradables." },
  { n: 13, fr: "Je refuse de croire que cela soit arrivé.", es: "Me niego a creer que haya sucedido." },
  { n: 14, fr: "J'essaie de voir les choses autrement, pour que cela paraisse plus positif.", es: "Intento verlo con otros ojos, para hacer que parezca más positivo." },
  { n: 15, fr: "Je consomme de l'alcool ou d'autres substances pour me sentir mieux.", es: "Utilizo alcohol u otras drogas para hacerme sentir mejor." },
  { n: 16, fr: "J'essaie de trouver du réconfort dans ma religion ou mes croyances spirituelles.", es: "Intento hallar consuelo en mi religión o creencias espirituales." },
  { n: 17, fr: "J'obtiens le réconfort et la compréhension de quelqu'un.", es: "Consigo el consuelo y la comprensión de alguien." },
  { n: 18, fr: "Je cherche quelque chose de positif dans ce qui se passe.", es: "Busco algo bueno en lo que está sucediendo." },
  { n: 19, fr: "Je ris de la situation.", es: "Me río de la situación." },
  { n: 20, fr: "Je prie ou je médite.", es: "Rezo o medito." },
  { n: 21, fr: "J'apprends à vivre avec.", es: "Aprendo a vivir con ello." },
  { n: 22, fr: "Je fais quelque chose pour y penser moins, comme aller au cinéma ou regarder la télévision.", es: "Hago algo para pensar menos en ello, tal como ir al cine o ver la televisión." },
  { n: 23, fr: "J'exprime mes sentiments négatifs.", es: "Expreso mis sentimientos negativos." },
  { n: 24, fr: "Je consomme de l'alcool ou d'autres substances pour m'aider à surmonter cela.", es: "Utilizo alcohol u otras drogas para ayudarme a superarlo." },
  { n: 25, fr: "Je renonce à essayer de faire face au problème.", es: "Renuncio al intento de hacer frente al problema." },
  { n: 26, fr: "Je réfléchis attentivement aux étapes à suivre.", es: "Pienso detenidamente sobre los pasos a seguir." },
  { n: 27, fr: "Je m'attribue la faute de ce qui est arrivé.", es: "Me echo la culpa de lo que ha sucedido." },
  { n: 28, fr: "J'obtiens que d'autres personnes m'aident ou me conseillent.", es: "Consigo que otras personas me ayuden o aconsejen." },
];

// category: 'adaptative' | 'evitante' | 'ambivalente'
export const COPE_STRATEGIES = [
  { key: "afrontamiento_activo", items: [2, 10], category: "adaptative", fr: "Coping actif", es: "Afrontamiento activo" },
  { key: "planificacion", items: [6, 26], category: "adaptative", fr: "Planification", es: "Planificación" },
  { key: "apoyo_emocional", items: [9, 17], category: "adaptative", fr: "Soutien émotionnel", es: "Apoyo emocional" },
  { key: "apoyo_social", items: [1, 28], category: "adaptative", fr: "Soutien social (instrumental)", es: "Apoyo social" },
  { key: "religion", items: [16, 20], category: "ambivalente", fr: "Religion / spiritualité", es: "Religión" },
  { key: "reevaluacion_positiva", items: [14, 18], category: "adaptative", fr: "Réévaluation positive", es: "Reevaluación positiva" },
  { key: "aceptacion", items: [3, 21], category: "adaptative", fr: "Acceptation", es: "Aceptación" },
  { key: "negacion", items: [5, 13], category: "evitante", fr: "Déni", es: "Negación" },
  { key: "humor", items: [7, 19], category: "ambivalente", fr: "Humour", es: "Humor" },
  { key: "autodistraccion", items: [4, 22], category: "evitante", fr: "Auto-distraction", es: "Autodistracción" },
  { key: "autoinculpacion", items: [8, 27], category: "evitante", fr: "Auto-accusation", es: "Autoinculpación" },
  { key: "desconexion", items: [11, 25], category: "evitante", fr: "Désengagement comportemental", es: "Desconexión conductual" },
  { key: "desahogo", items: [12, 23], category: "ambivalente", fr: "Décharge émotionnelle", es: "Desahogo emocional" },
  { key: "uso_sustancias", items: [15, 24], category: "evitante", fr: "Usage de substances", es: "Uso de sustancias" },
];

// Textes d'interface du module (bilingues).
export const COPE_T = {
  fr: {
    title: "COPE-28",
    subtitle: "Inventaire bref des stratégies de coping (Brief COPE)",
    allModules: "← Tous les modules",
    intro:
      "Ce questionnaire explore la manière dont vous faites habituellement face aux situations difficiles, tendues ou stressantes. Il comporte 28 affirmations. Il n'existe ni bonne ni mauvaise réponse.",
    start: "Commencer",
    consigne: "Consigne",
    consigneText:
      "Les affirmations décrivent des façons de penser, de ressentir ou de se comporter que l'on utilise pour faire face aux problèmes. Indiquez, pour chacune, dans quelle mesure elle correspond à votre manière habituelle d'y faire face.",
    resultsLater: "Vos scores et leur interprétation vous seront présentés uniquement à la fin.",
    begin: "Commencer la passation",
    prev: "Précédent",
    next: "Suivant",
    seeResults: "Voir mes résultats",
    step: "Étape",
    of: "sur",
    completeStep: "Merci de répondre à toutes les affirmations de cette étape pour continuer.",
    restart: "Nouvelle passation",
    exportPdf: "Exporter en PDF",
    levels: { faible: "Faible", modere: "Modéré", eleve: "Élevé" },
    disclaimer:
      "Ces résultats constituent un support de réflexion clinique et ne posent aucun diagnostic. Ils décrivent des tendances d'adaptation au stress au moment de la passation.",
    situationLabel: "À propos de quelle situation stressante répondez-vous ? (facultatif)",
    situationPlaceholder: "Décrivez brièvement la situation (ex. : conflit au travail, séparation, maladie…).",
    situationReport: "Situation évaluée",
    noSituation: "Aucune situation précisée.",
    balanceTitle: "Équilibre adaptatif / évitant",
    balanceSub: "Score moyen par type de stratégie (0–6)",
    catAdaptative: "Stratégies adaptatives",
    catAmbivalente: "Stratégies ambivalentes",
    catEvitante: "Stratégies d'évitement",
  },
  es: {
    title: "COPE-28",
    subtitle: "Inventario breve de estrategias de afrontamiento (Brief COPE)",
    allModules: "← Todos los módulos",
    intro:
      "Este cuestionario explora cómo sueles enfrentarte a las situaciones difíciles, tensas o estresantes. Consta de 28 frases. No hay respuestas correctas ni incorrectas.",
    start: "Empezar",
    consigne: "Instrucciones",
    consigneText:
      "Las frases describen formas de pensar, sentir o comportarse que la gente utiliza para enfrentarse a los problemas. Indica, para cada una, en qué medida refleja tu forma habitual de afrontamiento.",
    resultsLater: "Tus puntuaciones y su interpretación se mostrarán únicamente al final.",
    begin: "Comenzar el cuestionario",
    prev: "Anterior",
    next: "Siguiente",
    seeResults: "Ver mis resultados",
    step: "Etapa",
    of: "de",
    completeStep: "Responde a todas las frases de esta etapa para continuar.",
    restart: "Nueva pasación",
    exportPdf: "Exportar en PDF",
    levels: { faible: "Bajo", modere: "Moderado", eleve: "Alto" },
    disclaimer:
      "Estos resultados constituyen un apoyo de reflexión clínica y no establecen ningún diagnóstico. Describen tendencias de afrontamiento del estrés en el momento de la pasación.",
    situationLabel: "¿Sobre qué situación estresante respondes? (opcional)",
    situationPlaceholder: "Describe brevemente la situación (p. ej.: conflicto laboral, separación, enfermedad…).",
    situationReport: "Situación evaluada",
    noSituation: "Ninguna situación especificada.",
    balanceTitle: "Equilibrio adaptativo / evitativo",
    balanceSub: "Puntuación media por tipo de estrategia (0–6)",
    catAdaptative: "Estrategias adaptativas",
    catAmbivalente: "Estrategias ambivalentes",
    catEvitante: "Estrategias de evitación",
  },
};

export const LEVEL_COLORS = { faible: "#B0553B", modere: "#E99F4F", eleve: "#8A6D56" };

export const CATEGORY_COLORS = { adaptative: "#8A6D56", ambivalente: "#E99F4F", evitante: "#B0553B" };
